import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesHeroComponent } from '../../Components/Sales/sales-hero/sales-hero';
import { SalesOverviewComponent } from '../../Components/Sales/sales-overview/sales-overview';
import { SalesFeaturesComponent } from '../../Components/Sales/sales-features/sales-features';
import { SalesMobileComponent } from '../../Components/Sales/sales-mobile/sales-mobile';
import { SalesCtaComponent } from '../../Components/Sales/sales-cta/sales-cta';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-sales-page',
  standalone: true,
  imports: [
    CommonModule,
    SalesHeroComponent,
    SalesOverviewComponent,
    SalesFeaturesComponent,
    SalesMobileComponent,
    SalesCtaComponent,
  ],
  templateUrl: './sales-page.html',
  styleUrls: ['./sales-page.css'],
})
export class SalesPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Sale Mobilizer — POS & Sales Management',
      description:
        'Run your sales and stock from POS, mobile, and online orders. Fast billing, live inventory, and a customer ordering app — all connected in one system.',
      path: '/sales',
    });
  }
}
